export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6704.067a9094.jpg";